export const baseUrl = "/authorization";
